/* eslint-disable react/no-array-index-key */
/* eslint-disable no-alert */
/* eslint-disable no-lonely-if */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable arrow-body-style */
import React, {
  useState, useEffect, useRef,
} from 'react';

import { Link, useParams, useHistory } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, InputGroup, Button,
  Nav, NavItem, NavLink, TabContent, TabPane, Label,
} from 'reactstrap';
import {
  Table, Thead, Tbody, Tr, Td,
} from 'react-super-responsive-table';
import classnames from 'classnames';
import moment from 'moment';
// import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';

import { post, get, del } from '../../helpers/api_helper';
import BaseGrid from '../../components/Common/BaseGrid';
import {
  requiresCustoms, declaredCustomsValue, getContentsWeight, getCustomsErrors,
} from '../../helpers/shippingCustoms';

import { useScanner } from '../../utilities/ScannerContext';

function formatItemTotal(item) {
  const qty = parseFloat(item?.qty) || 0;
  const value = parseFloat(item?.value) || 0;

  return (qty * value).toFixed(2);
}

function normalizeItems(items = [], international = false) {
  return items.map((item) => {
    const normalized = {
      ...item,
      value: international ? declaredCustomsValue(item.value) : item.value,
    };
    return { ...normalized, total: formatItemTotal(normalized) };
  });
}

function assertCustomsComplete(values) {
  if (Object.keys(getCustomsErrors(values)).length) {
    document.getElementById('shipping-contents')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    throw new Error('Complete the required international contents fields below before getting rates or shipping.');
  }
}

function renderShipmentOrderLinks(shipment) {
  const orders = [...new Map(
    (shipment?.items || [])
      .map((item) => item?.order_item?.order)
      .filter((order) => order?.id != null)
      .map((order) => [order.id, order]),
  ).values()];

  if (orders.length === 0 && shipment?.order?.id != null) {
    orders.push(shipment.order);
  }

  if (orders.length === 0) {
    return '-';
  }

  return orders.map((order, index) => (
    <React.Fragment key={order.id}>
      {index > 0 && ', '}
      <Link to={`/orders/${order.id}`}>{order.reference || order.id}</Link>
    </React.Fragment>
  ));
}

function getPrimaryShipmentOrderId(shipment) {
  const shipmentOrderIds = [
    ...new Set(
      (shipment?.items || [])
        .map((item) => item?.order_item?.order_id)
        .filter((orderId) => orderId != null),
    ),
  ];

  if (shipmentOrderIds.length > 0) {
    return shipmentOrderIds[0];
  }

  return shipment?.order_id || null;
}

function normalizeShipMethodValue(value) {
  return `${value || ''}`.trim().toLowerCase();
}

function getCarrierFlags(mapping) {
  const carrier = `${mapping?.carrier || ''}`.trim().toLowerCase();

  return {
    ups_enable: carrier === 'ups',
    usps_enable: carrier === 'usps',
    fedex_enable: carrier === 'fedex',
  };
}

const AUTO_SELECT_CHEAPEST_CODES = ['AUTO_SELECT_CHEAPEST', 'AUTO_RATE_SHOP', 'CHEAPEST_RATE'];
const UPS_SUREPOST_SERVICE_CODES = ['92', '93', '94', '95'];

function isAutoSelectCheapestCode(shipMethodCode) {
  return AUTO_SELECT_CHEAPEST_CODES.includes(`${shipMethodCode || ''}`.trim().toUpperCase());
}

function isUpsSurePostRate(rate) {
  if (`${rate?.carrier || ''}`.trim().toUpperCase() !== 'UPS') {
    return false;
  }

  const serviceCode = `${rate?.service_code || ''}`.trim();
  const description = `${rate?.desc || ''}`.trim().toLowerCase();

  return UPS_SUREPOST_SERVICE_CODES.includes(serviceCode)
    || description.includes('surepost')
    || description.includes('ground saver');
}

function matchesReferencePattern(referencePattern, orderReference) {
  const normalizedPattern = `${referencePattern || ''}`.trim();

  if (normalizedPattern === '') {
    return true;
  }

  try {
    return new RegExp(normalizedPattern).test(`${orderReference || ''}`);
  } catch (error) {
    return false;
  }
}

function isPackageFieldComplete(value) {
  if (value == null) {
    return false;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return false;
  }

  return true;
}

function getFirstMissingPackageField(pkg = {}) {
  if (!isPackageFieldComplete(pkg?.dx)) {
    return 'dx';
  }

  if (!isPackageFieldComplete(pkg?.dy)) {
    return 'dy';
  }

  if (!isPackageFieldComplete(pkg?.dz)) {
    return 'dz';
  }

  if (!isPackageFieldComplete(pkg?.weight)) {
    return 'weight';
  }

  return null;
}

function findShipMethodMapping(shipMethod, weight = null, mappings = [], orderReference = '') {
  const normalizedShipMethod = normalizeShipMethodValue(shipMethod);

  if (normalizedShipMethod === '') {
    return null;
  }

  const matchingMappings = mappings
    .filter((mapping) => (mapping?.preferred_methods || [])
      .some((matchValue) => normalizeShipMethodValue(matchValue) === normalizedShipMethod))
    .filter((mapping) => matchesReferencePattern(mapping?.reference_match, orderReference))
    .sort((a, b) => Number(b?.id || 0) - Number(a?.id || 0));

  if (matchingMappings.length === 0) {
    return null;
  }

  if (weight == null || weight === '') {
    return matchingMappings[0];
  }

  const numericWeight = Number(weight);

  return matchingMappings.find((mapping) => (
    mapping?.max_weight == null
    || mapping?.max_weight === ''
    || numericWeight <= Number(mapping.max_weight)
  )) || null;
}

const blankShipObject = {
  shipment_id: '',
  lpn: '',
  order_number: '',
  po_number: '',
  hazmat: 0,
  package: {
    dx: '',
    dy: '',
    dz: '',
    weight: 0,
  },
  ship_to: {
    attention: '',
    company: '',
    address_1: '',
    address_1_suggested: null,
    address_2: '',
    address_2_suggested: null,
    city: '',
    state: '',
    zip: '',
    country: 'US',
    telephone: '',
    residential: false,
  },
  ship_from: {
    name: 'ShopJimmy.com',
    company: '',
    address_1: '2300 West Highway 13',
    address_2: '',
    city: 'Burnsville',
    state: 'MN',
    zip: '55337',
    country: 'US',
    telephone: '952-881-6492',
  },
  sold_to: {
    name: '',
    company: '',
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    zip: '',
    country: 'US',
    telephone: '',
  },
  items: [],
  service: {
    ups_enable: true,
    ups_package: '02',
    usps_enable: true,
    usps_package: 'Package',
    fedex_enable: true,
    fedex_package: 'YOUR_PACKAGING',
    code: null,
    selected_carrier: null,
    selected_service_name: null,
  },
  third_party: {
    ups: {
      account: '',
      company: '',
      postal_code: '',
      country_code: '',
    },
    fedex: {
      account: '',
      company: '',
      postal_code: '',
      country_code: '',
    },
  },
};

function Ship(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 8000,
  };

  const {
    connectScanner, registerListener, removeListener,
  } = useScanner();

  const dimsXRef = useRef(null);
  const dimsYRef = useRef(null);
  const dimsZRef = useRef(null);

  const weightRef = useRef(null);
  const lpnRef = useRef(null);

  const rateShopRef = useRef(null);

  const history = useHistory();
  const { shipmentId } = useParams();
  const [activeTab, setActiveTab] = useState('1');
  const [activeTab2, setActiveTab2] = useState('1');
  const [historySignal, setHistorySignal] = useState(0);
  const [validating, setValidating] = useState(false);
  const [shipping, setShipping] = useState(false);
  const [loadedLpn, setLoadedLpn] = useState(shipmentId);
  const [loadingShipmentContext, setLoadingShipmentContext] = useState(false);
  const [shipmentLookupFailed, setShipmentLookupFailed] = useState(false);

  const [shipObject, setShipObject] = useState(blankShipObject);
  const [orderObject, setOrderObject] = useState({});
  const [shipmentObject, setShipmentObject] = useState({});
  const [listeners, setListeners] = useState(false);
  const [scaleConnected, setScaleConnected] = useState(false);
  const [hazmatOptions, setHazmatOptions] = useState([]);

  const [, setSuggestions] = useState([]);
  const [services, setServices] = useState(null);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [shipMethodMappings, setShipMethodMappings] = useState([]);
  const [shipMethodMappingsLoading, setShipMethodMappingsLoading] = useState(true);
  const shipmentLoadRequestIdRef = useRef(0);
  const formikRef = useRef(null);
  const autoShippingRef = useRef(false);
  const shippingRequestInFlightRef = useRef(false);

  const { t } = props;

  const handleScan = (label) => {
    if (label !== null && label !== undefined) {
      if (label.match(/^[0-9]+$/)) {
        // LPN scanned
        setLoadedLpn(label);
      }
    }
  };

  const loadHazmatOptions = async () => {
    try {
      const options = await get('/api/warehouse/pack/hazmat');

      setHazmatOptions(options);
    } catch (error) {
      toastr.error(error.message, t('Error loading hazmat options'));
    }
  };

  const loadShipMethodMappings = async () => {
    try {
      setShipMethodMappingsLoading(true);
      const mappings = await get('/api/orders/shipping/mappings-active');
      setShipMethodMappings(Array.isArray(mappings) ? mappings : []);
    } catch (error) {
      setShipMethodMappings([]);
      toastr.error(error.message, t('Error loading ship method mappings'));
    } finally {
      setShipMethodMappingsLoading(false);
    }
  };

  // Connect to the scanner when the component mounts
  useEffect(() => {
    registerListener(handleScan);
    setListeners(true);
  }, [connectScanner]);

  useEffect(() => {
    const handleWindowFocus = () => {
      // Add listeners with a slight delay to avoid any re-registration issues
      if (!listeners) {
        registerListener(handleScan);
      }
    };

    const handleWindowBlur = async () => {
      // Remove listeners immediately when the window loses focus
      removeListener();
      setListeners(false);
    };

    loadHazmatOptions();
    loadShipMethodMappings();

    // Initial listener registration
    handleWindowFocus();

    lpnRef.current.focus();

    // Cleanup listeners on component unmount
    return () => {
      handleWindowBlur();
    };
  }, []);

  // Explicitly remove street type for comparison purposes.
  // Leave unit type (ste, apt, etc).
  const cleanedAddress = (addr) => {
    // Remove street type for comparison purposes
    const addrAbbreviations = ['street', 'st', 'road', 'rd', 'avenue', 'ave', 'boulevard', 'blvd', 'drive', 'dr', 'lane', 'ln', 'court', 'ct', 'circle', 'cir', 'place', 'pl', 'terrace', 'ter', 'way', 'calle', 'cll', 'hwy', 'highway'];
    let newAddr = addr.replace(/\n/g, ' ').replace(/\r/g, ' ').replace(/,/g, ' ').replace(/\s+/g, ' ')
      .trim();

    addrAbbreviations.forEach((abbr) => {
      const regex = new RegExp(`\\b${abbr}\\b`, 'gi');
      newAddr = newAddr.replace(regex, '');
    });

    return newAddr;
  };

  const validate = async (values) => {
    setValidating(true);

    try {
      const result = await post('/api/orders/ship/validate', values.ship_to);

      if (result.match !== false) {
        let addr2 = values.ship_to.address_2 || result.addr2;
        let remainder = '';
        const cleanedAddr = cleanedAddress(result.addr1);
        const cleanedOriginal = cleanedAddress(values.ship_to.address_1);
        const addr1Regex = new RegExp(`^${cleanedAddr.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'i');
        if (cleanedOriginal.match(addr1Regex)) {
          remainder = cleanedOriginal.replace(addr1Regex, '').trim().toUpperCase();
        } else {
          // look in original address line 1 for apt #s if line 2 empty
          const matches = values.ship_to.address_1.match(/\b((?:apt|lot|apartment|unit|suite|ste|floor|fl|room|rm|dept|space|bldg|building)\s*#?\s*\d+[a-zA-Z]?)|(#\d+.*)$\b/i);

          if (matches !== null) {
            addr2 = matches[0].trim();
            remainder = matches[0].trim();
          }
        }

        if (remainder === null || remainder.trim() === '') {
          addr2 = result.addr2 || values.ship_to.address_2;
        } else {
          addr2 = [values.ship_to.address_2?.toUpperCase() || '', remainder.trim().toUpperCase()].join(' ').trim();
        }

        setShipObject({
          ...values,
          ship_to: {
            ...values.ship_to,
            attention: result.name,
            address_1: values.ship_to.address_1.toUpperCase(),
            address_1_suggested: result.addr1.toUpperCase() ? '' : values.ship_to.address_1,
            address_2: values.ship_to.address_2.toUpperCase(),
            address_2_suggested: addr2,
            city: result.city,
            state: result.state,
            country: result.country,
            zip: `${result.zipcode}-${result.zipcode_addon}`,
            residential: orderObject.ship_method === 'FedEx Home Delivery' ? true : result.residential,
          },
        });
      }

      if (result.suggestions !== undefined) {
        setSuggestions(result.suggestions);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      toastr.error(error.message, 'Error');
    } finally {
      setValidating(false);
    }
  };

  const rateShop = async (values, options = {}) => {
    const { autoSelectCheapest = false } = options;

    setServices(null);
    setServicesLoading(true);

    try {
      assertCustomsComplete(values);
      const carriers = [
        { name: 'usps', enabled: values.service.usps_enable },
        { name: 'fedex', enabled: values.service.fedex_enable },
        { name: 'ups', enabled: values.service.ups_enable },
      ];
      const enabledCarriers = carriers.filter((carrier) => carrier.enabled === true);
      const requests = enabledCarriers
        .map((carrier) => post(`/api/orders/ship/rates/${carrier.name}`, {
          ...values,
          items: normalizeItems(values.items, requiresCustoms(values)),
        }));

      const results = await Promise.all(requests);

      let allRates = [];

      results.forEach((result, index) => {
        if (result && result.rates) {
          const carrierName = enabledCarriers[index].name.toUpperCase();
          allRates = [
            ...allRates,
            ...result.rates.map((rate) => ({ ...rate, carrier: carrierName })),
          ];
        } else if (results && results[index].errors && results[index].errors.length > 0) {
          toastr.error(`Error getting rates from ${enabledCarriers[index].name.toUpperCase()}: ${results[index].errors[0].description}`, 'Error');
        } else {
          toastr.error(`Error getting rates from ${enabledCarriers[index].name.toUpperCase()}`, 'Error');
        }
      });

      // Determine sort field and direction
      const sortField = 'rate'; // You can replace this with your state variable
      const sortDirection = 'asc'; // You can replace this with your state variable

      // Sort the array based on the chosen sort field and direction
      allRates.sort((a, b) => {
        if (sortDirection === 'asc') {
          return a[sortField] - b[sortField];
        }

        return b[sortField] - a[sortField];
      });

      setServices(allRates);

      if (autoSelectCheapest) {
        const cheapestRate = allRates.find((rate) => !isUpsSurePostRate(rate)) || null;

        if (!cheapestRate?.service_code) {
          throw new Error(t('Automatic rate shop did not return any rates to ship.'));
        }

        if (formikRef.current) {
          await formikRef.current.setFieldValue('service.code', cheapestRate.service_code);
          await formikRef.current.setFieldValue(
            'service.selected_carrier',
            cheapestRate.carrier || null,
          );
          await formikRef.current.setFieldValue(
            'service.selected_service_name',
            cheapestRate.desc || null,
          );
        }
      }
    } catch (error) {
      toastr.error(error.message, 'Error');
    } finally {
      setServicesLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const serviceMap = (service, weight = 1) => {
    switch (service.trim()) {
      case 'UPS UPS Next Day Air®':
      case 'UPS UPS Next Day Air':
        return '01';
      case 'UPS UPS Next Day Air Saver®':
      case 'UPS UPS Next Day Air Saver':
        return '13';
      case 'UPS UPS 2nd Day Air®':
      case 'UPS UPS 2nd Day Air':
      case 'UPS (UPS 2nd Day Air)':
        return '02';
      case 'UPS Ground':
      case 'UPS UPS Ground':
      case 'UPS UPS® Ground':
        return '03';
      case 'UPS UPS Worldwide Express':
      case 'UPS UPS Worldwide Express®':
        return '07';
      case 'UPS UPS Worldwide Expedited':
        return '08';
      case 'UPS UPS Standard':
      case 'UPS UPS® Standard':
        return '11';
      case 'UPS UPS Worldwide Express Plus':
        return '54';
      case 'UPS Worldwide Saver':
        return '65';
      case 'UPS UPS Worldwide Express Freight':
        return '96';
      case 'UPS UPS Worldwide Express Freight Midday':
        return '98';
      case 'UPS UPS Express Saver':
        return '65';
      case 'UPS UPS Express':
        return '07';
      case 'UPS UPS Express Plus':
        return '54';
      case 'UPS UPS Express Early A.M.':
        return '12';
      case 'UPS SurePost':
      case 'UPS SurePost®':
      case 'UPS SurePost® - Up to 7 Business Days (UPS SurePost®)':
      case 'UPS SurePost® - Up to 7 Business Days (UPS Ground Saver®)':
      case 'UPS Ground Saver - May take 7-10 days to deliver!':
      case 'UPS Ground Saver - Up to 7 Business Days (UPS Ground Saver®)':
        return '93';
      case 'USPS USPS Ground Advantage':
      case 'US Postal Service First-Class Mail':
        return 'US-GA';
      case 'USPS Priority Mail':
      case 'USPS USPS Priority Mail':
        return 'US-PM';
      case 'USPS First':
      case 'USPS First-Class Mail':
        return 'FCM';
      case 'USPS Priority Mail Express':
        return 'PME';
      case 'USPS First-Class Package Service':
        return 'FCPS';
      case 'USPS Parcel Select Ground':
        return 'PSG';
      case 'USPS Media Mail':
        return 'MM';
      case 'USPS Library Mail':
        return 'LM';
      case 'USPS Bound Printed Matter':
        return 'BPM';
      case 'USPS Standard Post':
        return 'SP';
      case 'USPS Parcel Select':
        return 'PS';
      case 'USPS Priority Mail Express International':
        return 'PMEI';
      case 'USPS Priority Mail International':
        return 'PMI';
      case 'USPS First-Class Package International Service':
        return 'FCPIS';
      case 'USPS First-Class Mail International':
        return 'FCMI';
      case 'USPS Global Express Guaranteed':
        return 'GXG';
      case 'USPS Priority Mail Express Flat Rate Envelope':
        return 'PMEFRE';
      case 'USPS Priority Mail Express Padded Flat Rate Envelope':
        return 'PMEPFRE';
      case 'USPS Priority Mail Express Sunday/Holiday Delivery':
        return 'PMESHD';
      case 'FedEx Ground':
      case 'FedEx Ground®':
      case 'fedex_FEDEX_GROUND':
      case 'FedEx Home Delivery':
        return 'FEDEX_GROUND';
      case 'FedEx 2-Day':
      case 'FedEx 2Day®':
      case 'fedex_FEDEX_2_DAY':
        return 'FEDEX_2_DAY';
      case 'FedEx 2Day® AM':
        return 'FEDEX_2_DAY_AM';
      case 'FedEx First Overnight®':
      case 'FedEx First Overnight':
        return 'FIRST_OVERNIGHT';
      case 'FedEx Standard Overnight®':
      case 'FedEx Standard Overnight':
      case 'fedex_STANDARD_OVERNIGHT':
        return 'STANDARD_OVERNIGHT';
      case 'FedEx Priority Overnight®':
      case 'FedEx Priority Overnight':
      case 'FedEx FedEx Next Day Air®':
      case 'FedEx FedEx Next Day Air':
      case 'fedex_PRIORITY_OVERNIGHT':
        return 'PRIORITY_OVERNIGHT';
      case 'FedEx Express Saver®':
      case 'FedEx Express Saver':
        return 'FEDEX_EXPRESS_SAVER';
      case 'FedEx International Economy':
        return 'INTERNATIONAL_ECONOMY';
      case 'FedEx International Priority':
        return 'INTERNATIONAL_PRIORITY';
      case 'Amazon Merchants@ Standard':
      case 'Newegg Standard Shipping (5-7 business days)':
      case 'Sears Ground':
      default:
        return null;
    }
  };

  useEffect(() => {
    if (loadedLpn !== '' && loadedLpn !== undefined) {
      history.push(`/ship/${loadedLpn}`);
    } else {
      history.push('/ship');
    }
  }, [loadedLpn]);

  useEffect(() => {
    if (loadedLpn === '' || loadedLpn === undefined) {
      setSuggestions([]);
      setLoadingShipmentContext(false);
      setShipmentLookupFailed(false);
      return;
    }

    if (shipMethodMappingsLoading) {
      return;
    }

    const fetchData = async () => {
      const requestId = shipmentLoadRequestIdRef.current + 1;
      shipmentLoadRequestIdRef.current = requestId;
      setLoadingShipmentContext(true);
      setShipmentLookupFailed(false);
      setShipmentObject({});
      setOrderObject({});

      try {
        const shipment = await get(`/api/orders/shipment/getByLpn/${loadedLpn}`);
        if (shipment !== '') {
          if (shipmentLoadRequestIdRef.current !== requestId) return;

          setShipmentObject(shipment);
          const primaryOrderId = getPrimaryShipmentOrderId(shipment);
          const order = (shipment.items || [])
            .map((item) => item?.order_item?.order)
            .find((shipmentOrder) => shipmentOrder?.id === primaryOrderId) || shipment.order;

          if (!primaryOrderId) {
            setShipmentLookupFailed(true);
            toastr.error(t('Unable to determine the order for this shipment.'));
            return;
          }

          if (!order) {
            setShipmentLookupFailed(true);
            toastr.error(t('Unable to load the order for this shipment.'));
            return;
          }

          if (order !== '' && order.void === 0 && order.shipped === 0) {
            // if (true) {
            setOrderObject(order);
            const shipmentItems = shipment.items || [];

            let dx = 0;
            let dy = 0;
            let dz = 0;
            let weight = 0;

            if (shipment.dimensions !== null) {
              [dx, dy, dz] = shipment.dimensions.split('x');
            }

            if (shipment.weight !== null) {
              weight = shipment.weight;
            } else {
              weight = shipmentItems.length === 1 && shipmentItems[0].order_item?.inventory
                && shipmentItems[0].order_item.inventory.ship_weight !== null
                ? shipmentItems[0].order_item.inventory.ship_weight : 0;
            }

            if (order.soldTo === null) {
              order.soldTo = order.shipTo;
            }

            // Remove ext. and +1 from telephone and make numbers between 10 and 15 digits max
            const telephone = order.shipTo.telephone
              ? order.shipTo.telephone.replace(' ext.', '').replace(/^\+1/, '').replace(/[^0-9-]/g, '').slice(0, 15)
              : '877-881-6492';
            const mappedService = findShipMethodMapping(
              order.ship_method,
              weight,
              shipMethodMappings,
              order.reference,
            );
            const carrierFlags = getCarrierFlags(mappedService);
            const shouldAutoSelectCheapest = isAutoSelectCheapestCode(
              mappedService?.ship_method_code,
            );
            const carrierFlagsForAutoSelectCheapest = mappedService?.carrier ? carrierFlags : {
              ups_enable: true,
              usps_enable: true,
              fedex_enable: false,
            };
            let serviceUpsEnabled = true;
            let serviceUspsEnabled = false;
            let serviceFedexEnabled = false;

            if (mappedService) {
              serviceUpsEnabled = carrierFlags.ups_enable;
              serviceUspsEnabled = carrierFlags.usps_enable;
              serviceFedexEnabled = carrierFlags.fedex_enable;
            }

            if (shouldAutoSelectCheapest) {
              serviceUpsEnabled = carrierFlagsForAutoSelectCheapest.ups_enable;
              serviceUspsEnabled = carrierFlagsForAutoSelectCheapest.usps_enable;
              serviceFedexEnabled = carrierFlagsForAutoSelectCheapest.fedex_enable;
            }

            const obj = {
              auto_format: true,
              shipment_id: shipment.id,
              lpn: loadedLpn,
              order_number: order.reference,
              po_number: order.po_number ? order.po_number : '',
              hazmat: shipment.hazmat,
              package: {
                dx,
                dy,
                dz,
                weight,
              },
              ship_to: {
                attention: `${order.shipTo.firstname} ${order.shipTo.lastname}`,
                company: order.shipTo.company ? order.shipTo.company.replace('&', 'and').substring(0, 30).trim() : '',
                address_1: order.shipTo.address_1,
                address_2: order.shipTo.address_2,
                city: order.shipTo.city,
                state: order.shipTo.region,
                zip: order.shipTo.postcode,
                country: order.shipTo.country,
                telephone,
                residential: false,
              },
              ship_from: {
                name: `${order.shipFrom.firstname} ${order.shipFrom.lastname}`.substring(0, 30).trim(),
                company: order.shipFrom.company,
                address_1: order.shipFrom.address_1,
                address_2: order.shipFrom.address_2,
                city: order.shipFrom.city,
                state: order.shipFrom.region,
                zip: order.shipFrom.postcode,
                country: order.shipFrom.country,
                telephone: order.shipFrom.telephone,
              },
              items: shipmentItems.map((item) => ({
                description: item.order_item.inventory_description ? item.order_item.inventory_description : '',
                qty: item.qty,
                value: item.order_item.value,
                total: item.qty * item.order_item.value,
                hts: item.order_item.inventory !== null ? item.order_item.inventory.ship_hts : '',
                // eslint-disable-next-line max-len
                weight: item.order_item.inventory !== null ? item.order_item.inventory.ship_weight || 0 : 0,
                currency_code: 'USD',
              })),
              service: {
                ups_enable: serviceUpsEnabled,
                ups_package: '02',
                usps_enable: serviceUspsEnabled,
                usps_package: 'Package',
                fedex_enable: serviceFedexEnabled,
                fedex_package: 'YOUR_PACKAGING',
                code: shouldAutoSelectCheapest ? null : mappedService?.ship_method_code || null,
              },
              third_party: {
                ups: {
                  account: order.ship_account ? order.ship_account : '',
                  company: '',
                  postal_code: order.ship_account_postcode || '',
                  country_code: 'US',
                },
                fedex: {
                  account: order.ship_account ? order.ship_account : '',
                  company: order.ship_account ? order.ship_account_company : '',
                  postal_code: order.ship_account_postcode || '',
                  country_code: 'US',
                },
              },
            };

            if (order.soldTo.address_1 !== null && order.soldTo.address_1 !== '') {
              obj.sold_to = {
                name: `${order.soldTo.firstname} ${order.soldTo.lastname}`.substring(0, 35).trim(),
                company: order.soldTo.company ? order.soldTo.company.replace('&', 'and').substring(0, 30).trim() : '',
                address_1: order.soldTo.address_1,
                address_2: order.soldTo.address_2,
                city: order.soldTo.city,
                state: order.soldTo.region,
                zip: order.soldTo.postcode,
                country: order.soldTo.country,
                telephone: order.soldTo.telephone ? order.soldTo.telephone : telephone,
              };
            } else {
              obj.sold_to = {
                name: `${order.shipTo.firstname} ${order.shipTo.lastname}`.substring(0, 35).trim(),
                company: order.shipTo.company ? order.shipTo.company.replace('&', 'and').substring(0, 30).trim() : '',
                address_1: order.shipTo.address_1,
                address_2: order.shipTo.address_2,
                city: order.shipTo.city,
                state: order.shipTo.region,
                zip: order.shipTo.postcode,
                country: order.shipTo.country,
                telephone,
              };
            }

            setShipObject(obj);
            await validate(obj);

            if (obj.service.code === null) {
              const firstMissingPackageField = getFirstMissingPackageField(obj.package);

              if (firstMissingPackageField == null) {
                rateShop(obj, { autoSelectCheapest: shouldAutoSelectCheapest });
              } else {
                window.setTimeout(() => {
                  if (formikRef.current) {
                    formikRef.current.setTouched({
                      package: {
                        dx: true,
                        dy: true,
                        dz: true,
                        weight: true,
                      },
                    }, true);
                  }

                  if (firstMissingPackageField === 'dx') {
                    dimsXRef.current?.focus();
                  } else if (firstMissingPackageField === 'dy') {
                    dimsYRef.current?.focus();
                  } else if (firstMissingPackageField === 'dz') {
                    dimsZRef.current?.focus();
                  } else {
                    weightRef.current?.focus();
                  }
                }, 0);
              }
            }
            setShipmentLookupFailed(false);
          } else {
            setShipmentLookupFailed(true);
            if (order.shipped === 1) {
              toastr.error(t('Order is shipped!'), 'Notice');
            } else if (order.void === 1) {
              toastr.error(t('Order is voided!'), 'Notice');
            } else {
              toastr.error(t('Order not found!'), 'Notice');
            }
          }
        } else if (loadedLpn !== undefined) {
          if (shipmentLoadRequestIdRef.current !== requestId) return;
          setShipmentLookupFailed(true);
          toastr.warning(t('Shipment not found'), 'Notice');
        }
      } catch (e) {
        if (shipmentLoadRequestIdRef.current !== requestId) return;
        setShipmentLookupFailed(true);
        toastr.error(e.message, 'Error');
      } finally {
        if (shipmentLoadRequestIdRef.current === requestId) {
          setLoadingShipmentContext(false);
        }
      }
    };

    setSuggestions([]);
    fetchData();
  }, [loadedLpn, shipMethodMappings, shipMethodMappingsLoading]);

  useEffect(() => {
    if (dimsXRef.current.value !== '') {
      if (weightRef.current.value === '') {
        weightRef.current.focus();
      }
    } else if (lpnRef.current.value === '') {
      lpnRef.current.focus();
    }
  }, [shipObject]);

  const resetFormBlank = () => {
    setShipObject(blankShipObject);

    setLoadedLpn(undefined);
    setShipmentObject({});
    setOrderObject({});
    setShipmentLookupFailed(false);
    setLoadingShipmentContext(false);
    setServices(null);
    lpnRef.current.focus();
  };

  const ship = async (values) => {
    if (shippingRequestInFlightRef.current) return;

    shippingRequestInFlightRef.current = true;
    setShipping(true);

    try {
      if (loadingShipmentContext) {
        throw new Error(t('Shipment is still loading. Please wait a moment and try again.'));
      }

      if (loadedLpn && loadedLpn !== '' && !values.shipment_id) {
        throw new Error(t('This LPN has not finished loading a shipment context yet. Reconnect the LPN before shipping.'));
      }

      assertCustomsComplete(values);

      const selectedRate = Array.isArray(services)
        ? services.find((rate) => rate?.service_code === values?.service?.code) || null
        : null;

      const result = await post('/api/orders/ship/ship', {
        ...values,
        service: {
          ...values.service,
          selected_carrier: selectedRate?.carrier || values?.service?.selected_carrier || null,
          selected_service_name:
            selectedRate?.desc || values?.service?.selected_service_name || null,
        },
        items: normalizeItems(values.items, requiresCustoms(values)),
      });

      if (result?.warnings && result.warnings.length > 0) {
        for (let i = 0; i < result.warnings.length; i += 1) {
          toastr.warning(result.warnings[i].description, 'Warning');
        }
      }

      if (result.errors && result.errors.length > 0) {
        for (let i = 0; i < result.errors.length; i += 1) {
          toastr.error(result.errors[i].description, 'Error');
        }
      } else {
        const paperless = [
          'AF', 'AL', 'AU', 'AT', 'BH', 'BB', 'BE', 'CA', 'GB', 'CN', 'HR', 'CY', 'CZ', 'DK', 'GB', 'EE', 'FI',
          'FR', 'DE', 'GU', 'HK', 'HU', 'IS', 'IN', 'ID', 'IE', 'IL', 'IT', 'CI', 'JM', 'JP', 'KR', 'LV', 'LI', 'LT',
          'LU', 'MO', 'MY', 'MH', 'MU', 'MX', 'FM', 'MC', 'NL', 'GB', 'MP', 'NO', 'PW', 'PS', 'PH', 'PL', 'PT', 'US',
          'PR', 'SM', 'GB', 'SG', 'SK', 'SI', 'ZA', 'ES', 'LK', 'SE', 'CH', 'TW', 'TH', 'TG', 'TN', 'VA', 'GB',
        ].includes(values.ship_to.country);

        setHistorySignal(historySignal + 1);
        resetFormBlank();

        if (!paperless) {
          const { token } = JSON.parse(localStorage.getItem('authUser'));

          window.open(`/api/orders/shipment/commercial-invoice/${shipmentObject.id}?token=${token}`, '_blank');
        }

        if (document.location.search.includes('terminal=1')) {
          window.close();
        } else {
          const createdTrackingNumber = result?.tracking_number || result?.label?.tracking_number;
          if (autoShippingRef.current) {
            toastr.info(t('Cheapest available rate selected automatically.'), t('Auto Ship'));
          }
          toastr.success(
            createdTrackingNumber ? `${createdTrackingNumber} created` : 'Shipping label created',
            'Success',
          );
        }
      }
    } catch (error) {
      toastr.error(error.response?.data?.error || error.response?.data || error.message, 'Error');
    } finally {
      autoShippingRef.current = false;
      shippingRequestInFlightRef.current = false;
      setShipping(false);
      lpnRef.current.focus();
    }
  };

  const printLabel = async (x) => {
    try {
      const printerId = localStorage.getItem('selectedPrinter');

      if (printerId === null) {
        toastr.error('No printer selected', 'Error');
        return;
      }

      await post(`/api/orders/ship/print/${printerId}/${x.id}`, {});
    } catch (error) {
      toastr.error(`Unable to print label: ${error.message}`, 'Error');
    }
  };

  const voidLabel = async (x) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm(t('Are you sure?'))) {
      try {
        await del(`/api/orders/ship/${x.id}`);

        toastr.success(t('Shipping label voided succefully'));

        setHistorySignal(historySignal + 1);
      } catch (err) {
        toastr.error(err.message, t('Error voiding shipping label'));
      }
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggle2 = (tab) => {
    if (activeTab2 !== tab) setActiveTab2(tab);
  };

  const focusField = (ref) => {
    ref.current.select(); // Select the text
  };

  const handleKeyDown = (e, nextFieldName) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default Enter behavior
      const nextField = document.getElementsByName(nextFieldName)[0];
      if (nextField) {
        nextField.focus();
      }
    }
  };

  const getEstimatedDeliveryDate = (deliveryTime) => {
    if (deliveryTime) {
      const date = moment(deliveryTime);
      if (date.isValid()) return date.format('dddd M/D');
    }

    const date = moment();
    let businessDays = 0;

    while (businessDays < 7) {
      date.add(1, 'day');
      if (date.isoWeekday() <= 5) businessDays += 1;
    }

    return date.format('dddd M/D');
  };

  function parseScaleData(dataView) {
    const scaleStatus = dataView.getUint8(0);

    // Stability check based on scale status byte
    const isStable = scaleStatus === 0x4 || scaleStatus === 0x2;

    if (!isStable) {
      return null;
    }

    const weightModulus = dataView.getUint8(3); // Lower byte of weight
    const weightScaling = dataView.getUint8(4) * 256; // Higher byte of weight
    const weight = weightModulus + weightScaling;

    let weightInLb = null;

    weightInLb = weight / 100; // default

    if (dataView.byteLength > 6) {
      switch (dataView.getUint8(6)) { // Unit byte
        case 3: // Scale reading in grams
          weightInLb = weight * 0.00220462; // Convert grams to pounds
          break;
        case 12: // Scale reading in pounds
          weightInLb = weight / 100; // Scale reports hundredths of a pound
          break;
        default:
          // console.error('Unknown weight unit:', dataView.getUint8(6));
          return null; // Unknown unit
      }
    }

    return {
      weightInLb,
      isStable,
    };
  }

  async function connectToScale(cb) {
    try {
      const filters = [{ vendorId: 0x0EB8, productId: 0xF000 }];
      const devices = await navigator.hid.requestDevice({ filters });
      if (devices.length === 0) {
        return;
      }

      const device = devices[0];
      await device.open();

      let accumulatedData = new Uint8Array(0);

      const concatenateUint8Arrays = (a, b) => {
        const result = new Uint8Array(a.length + b.length);
        result.set(a, 0);
        result.set(b, a.length);
        return result;
      };

      device.addEventListener('inputreport', (event) => {
        const { data } = event;
        const newData = new Uint8Array(data.buffer);

        if (newData.byteLength === 5) {
          accumulatedData = concatenateUint8Arrays(accumulatedData, newData);

          // Process accumulated data when there are enough bytes
          const dataView = new DataView(accumulatedData.buffer);
          const result = parseScaleData(dataView);
          if (result && result.isStable) {
            cb(result.weightInLb.toFixed(2));
          }

          // Remove processed bytes
          accumulatedData = accumulatedData.slice(6);
        }
      });

      setScaleConnected(true);
    } catch (error) {
      setScaleConnected(false);
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Formik
          innerRef={formikRef}
          enableReinitialize
          initialValues={shipObject}
          validate={getCustomsErrors}
          validationSchema={Yup.object().shape({
            auto_format: Yup.boolean(),
            lpn: Yup.string(),
            shipment_id: Yup.string(),
            order_number: Yup.string(),
            po_number: Yup.string(),
            hazmat: Yup.number(),
            package: Yup.object().shape({
              dx: Yup.number().required(),
              dy: Yup.number().required(),
              dz: Yup.number().required(),
              weight: Yup.number().required(),
            }),
            ship_to: Yup.object().shape({
              attention: Yup.string().required(),
              company: Yup.string(),
              address_1: Yup.string().required(),
              address_2: Yup.string().nullable(),
              city: Yup.string().required(),
              state: Yup.string().max(2, 'State must be 2 characters'),
              zip: Yup.string().required(),
              country: Yup.string().max(2, 'Country must be 2 characters').required(),
              telephone: Yup.string().required(),
              residential: Yup.boolean().required(),
            }),
            ship_from: Yup.object().shape({
              name: Yup.string().required(),
              company: Yup.string(),
              address_1: Yup.string().required(),
              city: Yup.string().required(),
              state: Yup.string().max(2, 'State must be 2 characters'),
              zip: Yup.string().required(),
              country: Yup.string().max(2).required(),
              telephone: Yup.string().required(),
            }),
            sold_to: Yup.object().when(['ship_to.country', 'ship_from.country'], {
              is: (shipToCountry, shipFromCountry) => shipToCountry !== shipFromCountry,
              then: (schema) => schema.shape({
                name: Yup.string().required('Name is required'),
                company: Yup.string().default('').nullable(),
                address_1: Yup.string().required('Address is required'),
                city: Yup.string().required('City is required'),
                state: Yup.string()
                  .max(2, 'State must be 2 characters'),
                zip: Yup.string().required('ZIP is required'),
                country: Yup.string()
                  .max(2, 'Country must be 2 characters')
                  .required('Country is required'),
                telephone: Yup.string().required('Telephone is required'),
              }),
              otherwise: (schema) => schema.shape({
                name: Yup.string().nullable(),
                company: Yup.string().default('').nullable(),
                address_1: Yup.string().nullable(),
                city: Yup.string().nullable(),
                state: Yup.string().max(2, 'State must be 2 characters').nullable(),
                zip: Yup.string().nullable(),
                country: Yup.string().max(2, 'Country must be 2 characters').nullable(),
                telephone: Yup.string().nullable(),
              }),
            }),
            items: Yup.array().of(
              Yup.object().shape({
                description: Yup.string(),
                qty: Yup.number().required(),
                value: Yup.number().required(),
                total: Yup.number().required(),
                hts: Yup.string().nullable(),
                weight: Yup.number(),
                currency_code: Yup.string().required(),
              }),
            ),
            service: Yup.object().shape({
              ups_enable: Yup.boolean(),
              ups_package: Yup.string(),
              usps_enable: Yup.boolean(),
              usps_package: Yup.string(),
              fedex_enable: Yup.boolean(),
              fedex_package: Yup.string(),
              code: Yup.string().required(),
              selected_carrier: Yup.string().nullable(),
              selected_service_name: Yup.string().nullable(),
            }),
            third_party: Yup.object().shape({
              ups: Yup.object().shape({
                account: Yup.string().nullable(),
                company: Yup.string().nullable(),
                postal_code: Yup.string(),
                country_code: Yup.string(),
              }),
              fedex: Yup.object().shape({
                account: Yup.string().nullable(),
                company: Yup.string().nullable(),
                postal_code: Yup.string(),
                country_code: Yup.string(),
              }),
            }),
          })}
          onSubmit={ship}
        >
          {({
            // eslint-disable-next-line no-unused-vars
            errors, setFieldValue, setFieldTouched, values, touched, resetForm,
          }) => {
            const international = requiresCustoms(values);
            const customsErrors = getCustomsErrors(values);
            const customsIncomplete = Object.keys(customsErrors).length > 0;
            const contentsWeight = getContentsWeight(values.items);
            const shippingBlockedByContext = loadingShipmentContext
              || (!!loadedLpn && loadedLpn !== '' && !values.shipment_id)
              || shipmentLookupFailed;

            return (
              <Form id="ShipForm" autoComplete="off">
                <Row className="mb-3">
                  <Col xl="3" className="mb-3">
                    <InputGroup>
                      <span className="input-group-text">{t('LPN')}</span>
                      <Field
                        name="lpn"
                        tabIndex={1}
                        onKeyDown={(e) => {
                          if (e.target.value !== '' && e.which === 13) {
                            e.preventDefault();
                            setLoadedLpn(e.target.value);
                          }
                        }}
                        onFocus={() => { focusField(lpnRef); }}
                        innerRef={lpnRef}
                        type="text"
                        className="form-control form-control-lg"
                      />
                      <Button
                        type="button"
                        color="success"
                        className="btn btn-soft-success btn-success"
                        disabled={loadingShipmentContext}
                        onClick={() => {
                          setLoadedLpn(values.lpn);
                        }}
                      >
                        <span className={`mdi ${loadingShipmentContext ? 'mdi-loading mdi-spin' : 'mdi-connection'}`} />
                      </Button>
                    </InputGroup>
                  </Col>
                  <Col xl="3" className="mb-3">
                    <InputGroup>
                      <Field name="package.dx" tabIndex={2} onKeyDown={(e) => handleKeyDown(e, 'package.dy')} onFocus={() => { focusField(dimsXRef); }} innerRef={dimsXRef} type="text" className={`form-control form-control-lg ${touched.package && touched.package.dx && errors.package && errors.package.dx ? 'border-danger' : 'border-default'} text-dark text-center`} />
                      <Field name="package.dy" tabIndex={3} onKeyDown={(e) => handleKeyDown(e, 'package.dz')} onFocus={() => { focusField(dimsYRef); }} innerRef={dimsYRef} type="text" className={`form-control form-control-lg ${touched.package && touched.package.dy && errors.package && errors.package.dy ? 'border-danger' : 'border-default'} text-dark text-center`} />
                      <Field name="package.dz" tabIndex={4} onKeyDown={(e) => handleKeyDown(e, 'package.weight')} onFocus={() => { focusField(dimsZRef); }} innerRef={dimsZRef} type="text" className={`form-control form-control-lg ${touched.package && touched.package.dz && errors.package && errors.package.dz ? 'border-danger' : 'border-default'} text-dark text-center`} />
                      <span className="input-group-text">{t('IN')}</span>
                    </InputGroup>
                  </Col>
                  <Col xl="3" className="mb-3">
                    <InputGroup>
                      <Button type="button" color="primary" className={`btn ${scaleConnected ? 'btn-warning' : 'btn-soft-warning'} text-dark`} onClick={() => { connectToScale((val) => { setFieldValue('package.weight', val); }); }}>
                        <span className="mdi mdi-scale" />
                      </Button>
                      <Field name="package.weight" tabIndex={5} onKeyDown={(e) => handleKeyDown(e, 'shipment_id')} onFocus={() => { focusField(weightRef); }} innerRef={weightRef} type="number" step=".1" className={`form-control form-control-lg ${touched.package && touched.package.weight && errors.package && errors.package.weight ? 'border-danger' : ''}`} />
                      <span className="input-group-text">{t('LBS')}</span>
                    </InputGroup>
                    {customsErrors.package?.weight && <div className="text-danger" role="alert">{t(customsErrors.package.weight)}</div>}
                  </Col>
                </Row>
                <Row>
                  <Col xl="5">
                    <Nav tabs className="border-default">
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={`${classnames({
                            active: (activeTab === '1'),
                          })} border-default`}
                          onClick={() => {
                            toggle('1');
                          }}
                        >
                          {t('Ship To')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={`${classnames({
                            active: (activeTab === '2'),
                          })} border-default`}
                          onClick={() => {
                            toggle('2');
                          }}
                        >
                          {t('Ship From')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={`${classnames({
                            active: (activeTab === '3'),
                          })} border-default`}
                          onClick={() => {
                            toggle('3');
                          }}
                        >
                          {t('Sold To')}
                        </NavLink>
                      </NavItem>
                      <NavItem className="position-relative">
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={`${classnames({
                            active: (activeTab === '5'),
                          })} border-default`}
                          onClick={() => {
                            toggle('5');
                          }}
                        >
                          {t('Validator')}
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent
                      activeTab={activeTab}
                    >
                      <TabPane tabId="1">
                        <Card>
                          <CardBody>
                            <div className="mb-3">
                              <Label for="ship_to_attention" className="text-dark">{t('Attention')}</Label>
                              <Field id="ship_to_attention" tabIndex={6} name="ship_to.attention" type="text" className="form-control" maxLength={35} />
                              <ErrorMessage name="ship_to.attention" component="div" className="text-danger" />
                            </div>
                            <div className="mb-3">
                              <Label for="ship_to_company" className="text-dark">{t('Company')}</Label>
                              <Field id="ship_to_company" tabIndex={7} name="ship_to.company" type="text" className="form-control" />
                              <ErrorMessage name="ship_to.company" component="div" className="text-danger" />
                            </div>
                            <div className="mb-3">
                              <Label for="ship_to_address" className="text-dark">{t('Address')}</Label>
                              <Field id="ship_to_address" tabIndex={8} name="ship_to.address_1" type="text" className="form-control" />
                              {values.ship_to?.address_1_suggested && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setFieldValue('ship_to.address_1', values.ship_to.address_1_suggested);
                                    setFieldValue('ship_to.address_1_suggested', null);
                                  }}
                                  className="btn btn-link p-0 alert-link text-danger"
                                >
                                  {t(`Suggested: ${values.ship_to.address_1_suggested || ''}`)}
                                </button>
                              )}
                              <ErrorMessage name="ship_to.address_1" component="div" className="text-danger" />
                              <Field name="ship_to.address_2" tabIndex={9} type="text" className="form-control mt-2" />
                              <ErrorMessage name="ship_to.address_2" component="div" className="text-danger" />
                              {values.ship_to?.address_2_suggested && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setFieldValue('ship_to.address_2', values.ship_to.address_2_suggested);
                                    setFieldValue('ship_to.address_2_suggested', null);
                                  }}
                                  className="btn btn-link p-0 alert-link text-danger"
                                >
                                  {t(`Suggested: ${values.ship_to.address_2_suggested || ''}`)}
                                </button>
                              )}
                            </div>
                            <div className="mb-3">
                              <Row>
                                <Col xl="4">
                                  <Label for="ship_to_city" className="text-dark">{t('City')}</Label>
                                  <Field id="ship_to_city" tabIndex={10} name="ship_to.city" type="text" className="form-control" />
                                  <ErrorMessage name="ship_to.city" component="div" className="text-danger" />
                                </Col>
                                <Col xl="4">
                                  <Label for="ship_to_state" className="text-dark">{t('State')}</Label>
                                  <Field id="ship_to_state" tabIndex={11} name="ship_to.state" type="text" className="form-control" />
                                  <ErrorMessage name="ship_to.state" component="div" className="text-danger" />
                                </Col>
                                <Col xl="4">
                                  <Label for="ship_to_zip" className="text-dark">{t('Zip')}</Label>
                                  <Field id="ship_to_zip" tabIndex={12} name="ship_to.zip" type="text" className="form-control" />
                                  <ErrorMessage name="ship_to.zip" component="div" className="text-danger" />
                                </Col>
                              </Row>
                            </div>
                            <div className="mb-3">
                              <Row>
                                <Col xl="4">
                                  <Label for="ship_to_country" className="text-dark">{t('Country')}</Label>
                                  <Field id="ship_to_country" tabIndex={13} name="ship_to.country" type="text" className="form-control" />
                                  <ErrorMessage name="ship_to.country" component="div" className="text-danger" />
                                </Col>
                                <Col xl="8">
                                  <Label for="ship_to_phone" className="text-dark">{t('Telephone')}</Label>
                                  <Field id="ship_to_phone" tabIndex={14} name="ship_to.telephone" type="text" className="form-control" />
                                  <ErrorMessage name="ship_to.telephone" component="div" className="text-danger" />
                                </Col>
                              </Row>
                            </div>
                            <Row className="mt-4">
                              <Col xxl="6">
                                <div className="form-check form-switch form-switch-md">
                                  <Field
                                    type="checkbox"
                                    onKeyDown={(e) => {
                                      if (e.target.value !== '' && e.which === 13) {
                                        e.preventDefault();
                                        setFieldValue('ship_to.residential', !values.ship_to.residential);
                                      }
                                    }}
                                    tabIndex={15}
                                    name="ship_to.residential"
                                    className="form-check-input"
                                    id="residential"
                                  />
                                  <Label className="form-check-label" for="residential">
                                    {t('Residential?')}
                                  </Label>
                                </div>
                              </Col>
                              <Col xxl="6">
                                <div className="float-end">
                                  <Button type="button" color="dark" className="btn me-3 btn-soft-dark" disabled={validating} onClick={() => { validate(values); }}>
                                    <span className={`mdi mdi-map-check ${validating ? 'mdi-spin' : ''}`} />
                                    {' '}
                                    {t('Validate')}
                                  </Button>
                                  {customsIncomplete && (
                                  <p className="text-danger" role="status">
                                    {t('International contents details are required.')}
                                    {' '}
                                    <a href="#shipping-contents">{t('Review Contents')}</a>
                                  </p>
                                  )}
                                  <Button type="submit" tabIndex={16} color="primary" disabled={shipping || validating || shippingBlockedByContext || customsIncomplete} className="btn btn-primary">
                                    <span className={`mdi mdi-truck ${shipping ? 'mdi-spin' : ''}`} />
                                    {' '}
                                    {loadingShipmentContext ? t('Loading Shipment...') : t('Ship')}
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </TabPane>

                      <TabPane tabId="2">
                        <Card>
                          <CardBody>
                            <div className="mb-3">
                              <Label for="ship_from_name" className="text-dark">{t('Name')}</Label>
                              <Field id="ship_from_name" name="ship_from.name" type="text" className="form-control" />
                              <ErrorMessage name="ship_from.name" component="div" className="text-danger" />
                            </div>
                            <div className="mb-3">
                              <Label for="ship_from_company" className="text-dark">{t('Company')}</Label>
                              <Field id="ship_from_company" name="ship_from.company" type="text" className="form-control" />
                              <ErrorMessage name="ship_from.company" component="div" className="text-danger" />
                            </div>
                            <div className="mb-3">
                              <Label for="ship_from_address" className="text-dark">{t('Address')}</Label>
                              <Field id="ship_from_address" name="ship_from.address_1" type="text" className="form-control" />
                              <ErrorMessage name="ship_from.address_1" component="div" className="text-danger" />
                              <Field name="ship_from.address_2" type="text" className="form-control mt-2" />
                            </div>
                            <div className="mb-3">
                              <Row>
                                <Col xl="4">
                                  <Label for="ship_from_city" className="text-dark">{t('City')}</Label>
                                  <Field id="ship_from_city" name="ship_from.city" type="text" className="form-control" />
                                  <ErrorMessage name="ship_from.city" component="div" className="text-danger" />
                                </Col>
                                <Col xl="4">
                                  <Label for="ship_from_state" className="text-dark">{t('State')}</Label>
                                  <Field id="ship_from_state" name="ship_from.state" type="text" className="form-control" />
                                  <ErrorMessage name="ship_from.state" component="div" className="text-danger" />
                                </Col>
                                <Col xl="4">
                                  <Label for="ship_from_zip" className="text-dark">{t('Zip')}</Label>
                                  <Field id="ship_from_zip" name="ship_from.zip" type="text" className="form-control" />
                                  <ErrorMessage name="ship_from.zip" component="div" className="text-danger" />
                                </Col>
                              </Row>
                            </div>
                            <div className="mb-3">
                              <Row>
                                <Col xl="4">
                                  <Label for="ship_from_country" className="text-dark">{t('Country')}</Label>
                                  <Field id="ship_from_country" name="ship_from.country" type="text" className="form-control" />
                                  <ErrorMessage name="ship_from.country" component="div" className="text-danger" />
                                </Col>
                                <Col xl="8">
                                  <Label for="ship_from_phone" className="text-dark">{t('Telephone')}</Label>
                                  <Field id="ship_from_phone" name="ship_from.telephone" type="text" className="form-control" />
                                  <ErrorMessage name="ship_from.telephone" component="div" className="text-danger" />
                                </Col>
                              </Row>
                            </div>
                          </CardBody>
                        </Card>
                      </TabPane>

                      <TabPane tabId="3">
                        <Card>
                          <CardBody>
                            <div className="mb-3">
                              <Label for="sold_to_name" className="text-dark">{t('Name')}</Label>
                              <Field id="sold_to_name" name="sold_to.name" type="text" className="form-control" />
                              <ErrorMessage name="sold_to.name" component="div" className="text-danger" />
                            </div>
                            <div className="mb-3">
                              <Label for="sold_to_company" className="text-dark">{t('Company')}</Label>
                              <Field id="sold_to_company" name="sold_to.company" type="text" className="form-control" />
                              <ErrorMessage name="sold_to.company" component="div" className="text-danger" />
                            </div>
                            <div className="mb-3">
                              <Label for="sold_to_address" className="text-dark">{t('Address')}</Label>
                              <Field id="sold_to_address" name="sold_to.address_1" type="text" className="form-control" />
                              <ErrorMessage name="sold_to.address_1" component="div" className="text-danger" />
                              <Field name="sold_to.address_2" type="text" className="form-control mt-2" />
                            </div>
                            <div className="mb-3">
                              <Row>
                                <Col xl="4">
                                  <Label for="sold_to_city" className="text-dark">{t('City')}</Label>
                                  <Field id="sold_to_city" name="sold_to.city" type="text" className="form-control" />
                                  <ErrorMessage name="sold_to.city" component="div" className="text-danger" />
                                </Col>
                                <Col xl="4">
                                  <Label for="sold_to_state" className="text-dark">{t('State')}</Label>
                                  <Field id="sold_to_state" name="sold_to.state" type="text" className="form-control" />
                                  <ErrorMessage name="sold_to.state" component="div" className="text-danger" />
                                </Col>
                                <Col xl="4">
                                  <Label for="sold_to_zip" className="text-dark">{t('Zip')}</Label>
                                  <Field id="sold_to_zip" name="sold_to.zip" type="text" className="form-control" />
                                  <ErrorMessage name="sold_to.zip" component="div" className="text-danger" />
                                </Col>
                              </Row>
                            </div>
                            <div className="mb-3">
                              <Row>
                                <Col xl="4">
                                  <Label for="sold_to_country" className="text-dark">{t('Country')}</Label>
                                  <Field id="sold_to_country" name="sold_to.country" type="text" className="form-control" />
                                  <ErrorMessage name="sold_to.country" component="div" className="text-danger" />
                                </Col>
                                <Col xl="8">
                                  <Label for="sold_to_phone" className="text-dark">{t('Telephone')}</Label>
                                  <Field id="sold_to_phone" name="sold_to.telephone" type="text" className="form-control" />
                                  <ErrorMessage name="sold_to.telephone" component="div" className="text-danger" />
                                </Col>
                              </Row>
                            </div>
                          </CardBody>
                        </Card>
                      </TabPane>

                      <TabPane tabId="5">
                        <Card>
                          <CardBody>
                            <div className="form-check form-switch form-switch-md">
                              <Field type="checkbox" name="auto_format" className="form-check-input" id="auto_format" />
                              <Label className="form-check-label" for="auto_format">
                                {t('Auto format ship-to address?')}
                              </Label>
                            </div>
                          </CardBody>
                        </Card>
                      </TabPane>
                    </TabContent>
                  </Col>
                  <Col xl="7">
                    <Nav tabs className="border-default" style={{ justifyContent: 'flex-end' }}>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={`${classnames({
                            active: (activeTab2 === '1'),
                          })} border-default`}
                          onClick={() => {
                            toggle2('1');
                          }}
                        >
                          {t('Service')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={`${classnames({
                            active: (activeTab2 === '4'),
                            'bg-warning': values.third_party?.ups?.account || values.third_party?.fedex?.account,
                          })} border-default`}
                          onClick={() => {
                            toggle2('4');
                          }}
                        >
                          {t('3rd Party Billing')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={`${classnames({
                            active: (activeTab2 === '3'),
                          })} border-default`}
                          onClick={() => {
                            toggle2('3');
                          }}
                        >
                          {t('History')}
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent
                      activeTab={activeTab2}
                    >
                      <TabPane tabId="1">
                        <Card>
                          <CardBody>
                            <Row>
                              <Col xl="6">
                                <div className="mb-3">
                                  <Label for="order_number" className="text-dark">{t('Order Number')}</Label>
                                  <Field name="order_number" type="text" className="form-control" />
                                </div>
                              </Col>
                              <Col xl="6">
                                <div className="mb-3">
                                  <Label for="po_number" className="text-dark">{t('PO Number')}</Label>
                                  <Field name="po_number" type="text" className="form-control" />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col xl="6">
                                <div className="mb-3">
                                  <label htmlFor="hazmat" className="form-label">{t('Hazmat Code')}</label>
                                  <Field
                                    as="select"
                                    name="hazmat"
                                    className={`form-control ${values.hazmat !== 0 && values.hazmat !== undefined ? 'bg-danger text-white' : ''}`}
                                  >
                                    {hazmatOptions.map((hz) => (
                                      <option value={hz.code}>{`${hz.code} - ${t(hz.description)}`}</option>
                                    ))}
                                  </Field>
                                </div>
                              </Col>
                            </Row>

                            {
                              shipmentId !== undefined
                              && orderObject.id !== undefined
                              && orderObject.customer_note !== null && (
                                <>
                                  <h6 className="mt-3">{t('Customer Note')}</h6>
                                  <blockquote className="blockquote">
                                    <p className="mb-0">{orderObject.customer_note}</p>
                                  </blockquote>
                                </>
                              )
                            }

                            {
                              shipmentId !== undefined
                              && orderObject.id !== undefined
                              && orderObject.staff_note !== '' && (
                                <>
                                  <h6 className="mt-3">{t('Staff Note')}</h6>
                                  <blockquote className="blockquote">
                                    <p className="mb-0 text-danger">{orderObject.staff_note}</p>
                                  </blockquote>
                                </>
                              )
                            }

                            {
                              shipmentId !== undefined
                              && orderObject.id !== undefined && (
                                <>
                                  <h6 className="mt-3">{t('Preferred Shipping Method')}</h6>
                                  <p className={`mb-0 ${values.service && values.service.code === null ? 'text-danger' : ''}`}>{orderObject.ship_method}</p>
                                </>
                              )
                            }

                            <Row className="mt-3">
                              <Col xl="4">
                                <div className="mb-3">
                                  <div className="form-check form-check-info">
                                    <Field type="checkbox" name="service.ups_enable" className="form-check-input mt-2" id="ups_enable" />
                                    <Label for="ups_enable" className="text-dark">
                                      <span className="fab fa-ups fs-1 text-primary" alt={t('UPS')} />
                                    </Label>
                                  </div>
                                  <Field as="select" name="service.ups_package" type="text" className="form-control">
                                    <option value="02">Your Packaging</option>
                                    <option value="01">UPS Letter</option>
                                    <option value="03">Tube</option>
                                    <option value="04">PAK</option>
                                    <option value="21">Express Box</option>
                                    <option value="24">25KG Box</option>
                                    <option value="25">10KG Box</option>
                                    <option value="30">Pallet</option>
                                    <option value="2a">Small Express Box</option>
                                    <option value="2b">Medium Express Box</option>
                                    <option value="2c">Large Express Box</option>
                                    <option value="56">Flats (Mail Innovation)</option>
                                    <option value="57">Parcels (Mail Innovation)</option>
                                    <option value="58">BPM (Mail Innovation)</option>
                                  </Field>
                                </div>
                              </Col>
                              <Col xl="4">
                                <div className="mb-3">
                                  <div className="form-check form-check-info">
                                    <Field type="checkbox" name="service.usps_enable" className="form-check-input mt-2" id="usps_enable" />
                                    <Label for="usps_enable" className="text-dark">
                                      <span className="fab fa-usps fs-1 text-info" alt={t('USPS')} />
                                    </Label>
                                  </div>
                                  <Field as="select" name="service.usps_package" type="text" className="form-control">
                                    <option value="Letter">Letter</option>
                                    <option value="Large Envelope or Flat">Large Envelope or Flat</option>
                                    <option value="Thick Envelope">Thick Envelope</option>
                                    <option value="Flat Rate Padded Envelope">Flat Rate Padded Envelope</option>
                                    <option value="Package">Package</option>
                                    <option value="Flat Rate Box">Flat Rate Box</option>
                                    <option value="Small Flat Rate Box">Small Flat Rate Box</option>
                                    <option value="Large Flat Rate Box">Large Flat Rate Box</option>
                                    <option value="Flat Rate Envelope">Flat Rate Envelope</option>
                                    <option value="Large Package">Large Package</option>
                                    <option value="Oversized Package">Oversized Package</option>
                                    <option value="Regional Rate Box A">Regional Rate Box A</option>
                                    <option value="Regional Rate Box B">Regional Rate Box B</option>
                                    <option value="Regional Rate Box C">Regional Rate Box C</option>
                                  </Field>
                                </div>
                              </Col>
                              <Col xl="4">
                                <div className="mb-3">
                                  <div className="form-check form-check-info">
                                    <Field type="checkbox" name="service.fedex_enable" className="form-check-input mt-2" id="fedex_enable" />
                                    <Label for="fedex_enable" className="text-dark">
                                      <span className="fab fa-fedex fs-1" style={{ color: '#e53004' }} alt={t('Fedex')} />
                                    </Label>
                                  </div>
                                  <Field as="select" name="service.fedex_package" type="text" className="form-control">
                                    <option value="YOUR_PACKAGING">Your Packaging</option>
                                    <option value="FEDEX_EXTRA_LARGE_BOX">Extra Large Box</option>
                                    <option value="FEDEX_LARGE_BOX">Large Box</option>
                                    <option value="FEDEX_MEDIUM_BOX">Medium Box</option>
                                    <option value="FEDEX_SMALL_BOX">Small Box</option>
                                    <option value="FEDEX_10KG_BOX">10KG Box</option>
                                    <option value="FEDEX_25KG_BOX">25KG Box</option>
                                    <option value="FEDEX_BOX">Box</option>
                                    <option value="FEDEX_ENVELOPE">Envelope</option>
                                    <option value="FEDEX_PAK">Pak</option>
                                    <option value="FEDEX_TUBE">Tube</option>
                                  </Field>
                                </div>
                              </Col>
                            </Row>

                            <div className="mt-3">
                              {customsIncomplete && (
                              <p className="text-danger">
                                {t('Complete the required international contents details below to get rates.')}
                                {' '}
                                <a href="#shipping-contents">{t('Review Contents')}</a>
                              </p>
                              )}
                              <Button type="button" color="danger" innerRef={rateShopRef} disabled={servicesLoading || customsIncomplete} className="float-end btn btn-sm btn-soft-danger text-dark" onClick={() => { rateShop(values); }}>
                                <span className="mdi mdi-usd" />
                                {' '}
                                {servicesLoading === true ? t('Shopping...') : t('Rate Shop')}
                              </Button>

                              {orderObject.id && (
                                <h6>
                                  {`${t('Shipping Budget')}: `}
                                  <strong>
                                    {`$${Number(orderObject?.shipping_budget).toFixed(2) || Number(0).toFixed(2)}`}
                                  </strong>
                                </h6>
                              )}
                              <div style={{ clear: 'right' }} />
                            </div>

                            {servicesLoading === false && services !== null && (
                              <div>
                                <Table className="table table-bordered mt-3">
                                  <Thead>
                                    <Tr>
                                      <th>{t('')}</th>
                                      <th>{t('Service')}</th>
                                      <th>{t('Rate')}</th>
                                      <th>{t('Est. Delivery')}</th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {services !== null && services.map((service, i) => (
                                      // eslint-disable-next-line react/no-array-index-key
                                      <Tr key={`svc_${i}`}>
                                        <Td>
                                          <Field type="radio" name="service.code" id={`svc_${service.service_code}`} value={service.service_code} />
                                        </Td>
                                        <Td>
                                          <Label for={`svc_${service.service_code}`}>{service.desc === 'UPS SurePost' ? 'UPS Ground Saver' : service.desc}</Label>
                                        </Td>
                                        <Td>
                                          {orderObject.id && (
                                            <strong className={Number(orderObject?.shipping_budget) < service.rate ? 'text-danger' : 'text-success'}>{service.rate.toFixed(2)}</strong>
                                          )}
                                          {!orderObject.id && (
                                            <strong>{service.rate.toFixed(2)}</strong>
                                          )}
                                          {' '}
                                          {service.currency}
                                        </Td>
                                        <Td>
                                          {
                                        getEstimatedDeliveryDate(service?.est_delivery_time)
                                        }
                                        </Td>
                                      </Tr>
                                    ))}
                                  </Tbody>
                                </Table>
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </TabPane>
                      <TabPane tabId="2">
                        <Card>
                          <CardBody>
                            <div />
                          </CardBody>
                        </Card>
                      </TabPane>
                      <TabPane tabId="3">
                        <Card>
                          <CardBody>
                            <div>
                              {activeTab2 === '3' && (
                                <BaseGrid
                                  url="/api/orders/ship/history"
                                  shouldUpdate={historySignal}
                                  hasSearch
                                  config={
                                    {
                                      columns: {
                                        created_at: {
                                          label: 'Created',
                                          date: {
                                            format: (date) => (moment(date).fromNow()),
                                            timezone: process.env.REACT_APP_LOCAL_TZ,
                                          },
                                          sort: true,
                                        },
                                        tracking_number: {
                                          label: props.t('Tracking'),
                                        },
                                        zpl_hex_id: {
                                          label: props.t('ZPL HEX ID'),
                                        },
                                        shipment_id: {
                                          label: props.t('ID'),
                                        },
                                        lpn: {
                                          label: props.t('LPN'),
                                          format: (f, x) => x.shipment?.lpn,
                                        },
                                        order_id: {
                                          label: props.t('Order'),
                                          format: (x, obj) => (obj.shipment ? renderShipmentOrderLinks(obj.shipment) : '-'),
                                          translate: false,
                                        },
                                        cost: {
                                          label: props.t('Rate'),
                                          format: (x, obj) => (obj.cost !== null ? `$${parseFloat(obj.cost).toFixed(2)}` : '-'),
                                        },
                                        actions: {
                                          label: props.t('Actions'),
                                          actions: [
                                            {
                                              key: 'print',
                                              icon: 'mdi mdi-printer',
                                              class: 'btn btn-sm btn-warning btn-soft-warning text-dark',
                                              alt: props.t('Print'),
                                              click: printLabel,
                                            },
                                            {
                                              key: 'void',
                                              icon: 'mdi mdi-close-thick',
                                              class: 'btn btn-sm btn-danger btn-soft-danger',
                                              alt: props.t('Void'),
                                              click: voidLabel,
                                            },
                                          ],
                                        },
                                      },
                                      pagination: {
                                        sort: 'created_at',
                                        direction: 'desc',
                                        perPage: 10,
                                      },
                                    }
                                  }
                                />
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      </TabPane>
                      <TabPane tabId="4">
                        <Card>
                          <CardBody>
                            <div>
                              <Row>
                                <Col xl="6">
                                  <div className="mb-3">
                                    <Label for="ups_account" className="text-dark">{t('UPS Account')}</Label>
                                    <Field name="third_party.ups.account" type="text" className="form-control" />
                                  </div>

                                  <Row className="mb-3">
                                    <Col sm="6">
                                      <Label for="ups_postal_code" className="text-dark">{t('UPS Account Postal Code')}</Label>
                                      <Field name="third_party.ups.postal_code" type="text" className="form-control" />
                                    </Col>
                                    <Col sm="6">
                                      <Label for="ups_country_code" className="text-dark">{t('UPS Account Country Code')}</Label>
                                      <Field name="third_party.ups.country_code" type="text" className="form-control" />
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xl="6">
                                  <div className="mb-3">
                                    <Label for="fedex_account" className="text-dark">{t('Fedex Account')}</Label>
                                    <Field name="third_party.fedex.account" type="text" className="form-control" />
                                  </div>

                                  <div className="mb-3">
                                    <Label for="fedex_company" className="text-dark">{t('Fedex Account Company')}</Label>
                                    <Field name="third_party.fedex.company" type="text" className="form-control" />
                                  </div>

                                  <Row>
                                    <Col sm="6">
                                      <Label for="fedex_postal_code" className="text-dark">{t('Fedex Account Postal Code')}</Label>
                                      <Field name="third_party.fedex.postal_code" type="text" className="form-control" />
                                    </Col>
                                    <Col sm="6">
                                      <Label for="fedex_country_code" className="text-dark">{t('Fedex Account Country Code')}</Label>
                                      <Field name="third_party.fedex.country_code" type="text" className="form-control" />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          </CardBody>
                        </Card>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <Card>
                      <CardHeader id="shipping-contents" className="bg-transparent border-bottom">
                        {t('Contents')}
                        {international && <span className="text-danger ms-2">{t('Required for international shipping')}</span>}
                      </CardHeader>
                      <CardBody>
                        {international && (
                          <div aria-live="polite">
                            <p className="text-muted">{t('Fields marked * are required. Zero values, including warranty items, are declared as 1. Contents weight includes quantity × weight each.')}</p>
                            <p className={customsErrors.customsWeight ? 'text-danger' : 'text-dark'}>
                              {t('Total contents weight')}
                              :
                              {contentsWeight.toFixed(3)}
                              {' '}
                              {t('lb')}
                              {' '}
                              /
                              {' '}
                              {t('Package weight')}
                              :
                              {' '}
                              {values.package?.weight || '—'}
                              {' '}
                              {t('lb')}
                            </p>
                            {customsIncomplete && <div className="alert alert-danger" role="alert">{t('Complete the required contents fields and correct any weight errors before getting rates or shipping.')}</div>}
                            {customsErrors.customsWeight && <div className="text-danger mb-2">{t(customsErrors.customsWeight)}</div>}
                            {customsErrors.package?.weight && <div className="text-danger mb-2">{t(customsErrors.package.weight)}</div>}
                            {typeof customsErrors.items === 'string' && <div className="text-danger mb-2">{t(customsErrors.items)}</div>}
                          </div>
                        )}
                        <FieldArray name="items">
                          {({ push, remove }) => {
                            return (
                              <>
                                <div className="mb-2">
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => push({
                                      description: '',
                                      qty: '1',
                                      hts: '',
                                      value: '',
                                      weight: '',
                                      currency_code: 'USD',
                                      total: 0,
                                    })}
                                  >
                                    <span className="mdi mdi-plus-thick" />
                                  </Button>
                                </div>

                                {values.items && values.items.length > 0 ? (
                                  <div className="table-responsive mt-3">
                                    <Table className="table table-sm table-bordered">
                                      <thead>
                                        <tr>
                                          <th>
                                            {t('Description')}
                                            {international && ' *'}
                                          </th>
                                          <th>
                                            {t('Qty')}
                                            {international && ' *'}
                                          </th>
                                          <th>{t('HTS Code')}</th>
                                          <th>
                                            {t('Value Ea')}
                                            {international && ' *'}
                                          </th>
                                          <th>{t('Total Value')}</th>
                                          <th>
                                            {t('Weight Ea (lb)')}
                                            {international && ' *'}
                                          </th>
                                          <th>{t('Currency Code')}</th>
                                          <th> </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {values.items.map((item, k) => (
                                          <tr key={`item_${k}`}>
                                            <td className="align-middle">
                                              <Field
                                                name={`items[${k}].description`}
                                                type="text"
                                                required={international}
                                                aria-required={international}
                                                aria-invalid={
                                                  !!customsErrors.items?.[k]?.description
                                                }
                                                aria-describedby={`contents-${k}-description-error`}
                                                className={`form-control ${customsErrors.items?.[k]?.description ? 'is-invalid' : ''}`}
                                                style={{ minWidth: '300px' }}
                                              />
                                              {customsErrors.items?.[k]?.description && <div id={`contents-${k}-description-error`} className="text-danger">{t(customsErrors.items[k].description)}</div>}
                                            </td>
                                            <td className="align-middle">
                                              <Field
                                                name={`items[${k}].qty`}
                                                type="number"
                                                step="any"
                                                min={international ? 0 : undefined}
                                                required={international}
                                                aria-required={international}
                                                aria-invalid={!!customsErrors.items?.[k]?.qty}
                                                aria-describedby={`contents-${k}-qty-error`}
                                                className={`form-control ${customsErrors.items?.[k]?.qty ? 'is-invalid' : ''}`}
                                              />
                                              {customsErrors.items?.[k]?.qty && <div id={`contents-${k}-qty-error`} className="text-danger">{t(customsErrors.items[k].qty)}</div>}
                                            </td>
                                            <td className="align-middle">
                                              <Field name={`items[${k}].hts`} type="number" className="form-control" />
                                            </td>
                                            <td className="align-middle">
                                              <Field
                                                name={`items[${k}].value`}
                                                type="number"
                                                step="any"
                                                min={international ? 0 : undefined}
                                                required={international}
                                                aria-required={international}
                                                aria-invalid={!!customsErrors.items?.[k]?.value}
                                                aria-describedby={`contents-${k}-value-error`}
                                                className={`form-control ${customsErrors.items?.[k]?.value ? 'is-invalid' : ''}`}
                                                onBlur={(event) => {
                                                  setFieldTouched(`items[${k}].value`, true);
                                                  if (international) setFieldValue(`items[${k}].value`, declaredCustomsValue(event.target.value));
                                                }}
                                              />
                                              {customsErrors.items?.[k]?.value && <div id={`contents-${k}-value-error`} className="text-danger">{t(customsErrors.items[k].value)}</div>}
                                              {international && declaredCustomsValue(item.value) === 1 && Number(item.value) === 0 && <small className="text-muted">{t('Zero value will be declared as 1.')}</small>}
                                            </td>
                                            <td className="align-middle">
                                              <input
                                                type="number"
                                                className="form-control"
                                                value={formatItemTotal({
                                                  ...item,
                                                  value: international
                                                    ? declaredCustomsValue(item.value) : item.value,
                                                })}
                                                readOnly
                                                tabIndex={-1}
                                              />
                                            </td>
                                            <td className="align-middle">
                                              <Field
                                                name={`items[${k}].weight`}
                                                step="any"
                                                min={international ? 0 : undefined}
                                                type="number"
                                                required={international}
                                                aria-required={international}
                                                aria-invalid={!!customsErrors.items?.[k]?.weight}
                                                aria-describedby={`contents-${k}-weight-error`}
                                                className={`form-control ${customsErrors.items?.[k]?.weight ? 'is-invalid' : ''}`}
                                              />
                                              {customsErrors.items?.[k]?.weight && <div id={`contents-${k}-weight-error`} className="text-danger">{t(customsErrors.items[k].weight)}</div>}
                                            </td>
                                            <td className="align-middle">
                                              <Field
                                                name={`items[${k}].currency_code`}
                                                type="text"
                                                className="form-control"
                                              />
                                            </td>
                                            <td className="text-center align-middle">
                                              <Button
                                                color="danger"
                                                size="sm"
                                                onClick={() => remove(k)}
                                              >
                                                <span className="mdi mdi-delete" />
                                              </Button>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  </div>
                                ) : (
                                  <p>{t('Waiting for a shipment to be loaded...')}</p>
                                )}
                              </>
                            );
                          }}
                        </FieldArray>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

Ship.defaultProps = {
  t: (x) => (x),
};

Ship.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Ship));
